import { ApiEndpoints } from '@/types/routes';
import { IHttpClient } from '@/api/HttpClient';
import {
  IMarketPriceDto,
  IMarketPricesApi,
  IMarketPricesDailyRequest,
} from '@/api/marketPrices/marketPrices.types';

export class MarketPricesApi implements IMarketPricesApi {
  private getBaseUrl(): string {
    return ApiEndpoints.MARKET_PRICES;
  }

  constructor(private readonly httpClient: IHttpClient) {}

  getMarketPricesDaily(payload: IMarketPricesDailyRequest) {
    const params = {
      ...payload,
    };

    return this.httpClient.get<IMarketPriceDto[]>(`${this.getBaseUrl()}daily/`, { params });
  }
}
